export enum CellInsertType {
  AFTER = "AFTER",
  BEFORE = "BEFORE",
  GLOBAL = "GLOBAL",
}
